import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { GetStartedComponent } from '@shared/get-started/get-started.component';
import { AvatarComponent } from '@content/home/hero-block/avatar/avatar.component';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';

@Component({
    selector: 'companyid-hero-block',
    imports: [NgOptimizedImage, AssetPipe, GetStartedComponent, AvatarComponent, ContentWrapperComponent],
    templateUrl: './hero-block.component.html',
    styleUrl: './hero-block.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroBlockComponent {}
